import { createChatSendQueue } from './chat-send-queue'

// Per Nuxt application, not module-global (no cross-request/account state).
export function createChatOutbox ({ getAccountId, post, sent, report }) {
  let accountId = null
  let queue = null
  const listeners = new Set()
  const changed = change => listeners.forEach(listener => listener(change))
  function getQueue () {
    const id = getAccountId()
    if (id !== accountId) {
      queue?.dispose()
      queue = null
      accountId = id
    }
    if (id != null && !queue) {
      queue = createChatSendQueue({ authorId: id, isActive: () => getAccountId() === id,
        post, sent, report, changed })
    }
    return queue
  }
  return {
    enqueue: message => getQueue()?.enqueue(message),
    retry: (clientId, userId) => getQueue()?.retry(clientId, userId),
    confirm: messages => getQueue()?.confirm(messages),
    messages: userId => getQueue()?.messages(userId) || [],
    hasUnsent: () => getQueue()?.hasUnsent() || false,
    subscribe (listener) {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    reset () {
      queue?.dispose()
      queue = null
      accountId = null
      changed({ reset: true })
    }
  }
}
